import { createTheme } from "@material-ui/core/styles";
export const mainTheme = createTheme({
  palette: {
    primary: {
      light: "#286c8d",
      main: "#173E51",
      dark: "#112f3d",
      contrastText: "#fff",
    },
    secondary: {
      light: "#fcc77f",
      main: "#FAA22B",
      dark: "##e19126",
      contrastText: "#000",
    },
  },
});



// WEBPACK FOOTER //
// ./src/styles/theme.js